// eslint-disable-next-line import/prefer-default-export
export const PASSWORD_RULES = {
  MIN_LENGTH: 10,
  UPPERCASE_REGEX: /(?=.*[A-Z])/,
  LOWERCASE_REGEX: /(?=.*[a-z])/,
  NUMBER_REGEX: /(?=.*[0-9])/,
  SPECIAL_CHAR_REGEX: /(?=.*[!@#$%^&*\-_])/,
};
